import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff5a90b0")

_pushScopeId("data-v-ff5a90b0")
const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { "data-testid": "pickup-detail-shipment-id" }
const _hoisted_3 = {
  key: 0,
  class: "pickup-detail-header__separator rounded-full"
}
const _hoisted_4 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_5 = {
  key: 0,
  "data-testid": "pickup-detail-dg-badge",
  class: "pr-1 rounded font-semibold text-12px bg-pink-lp-200 text-red-lp-1200"
}
const _hoisted_6 = {
  key: 1,
  "data-testid": "pickup-detail-k-badge",
  class: "px-1 rounded font-semibold text-12px bg-yellow-lp-200 text-yellow-lp-100"
}
const _hoisted_7 = {
  key: 2,
  "data-testid": "pickup-detail-kayu-badge",
  class: "rounded px-1.5 bg-chocolate-lp-400 text-white font-medium text-12px"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("pickup.detail.header.title", { pickupId: _ctx.pickupId })), 1),
    (_ctx.hasAnyBadge)
      ? (_openBlock(), _createBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.hasAnyBadge)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          (_ctx.hasDangerousGoods)
            ? (_openBlock(), _createBlock("span", _hoisted_5, " DG "))
            : _createCommentVNode("", true),
          (_ctx.hasQuarantine)
            ? (_openBlock(), _createBlock("span", _hoisted_6, " K "))
            : _createCommentVNode("", true),
          (_ctx.hasWoodPacking)
            ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("pickup.detail.header.woodPacking")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
})